import React from "react";
import { AreaChart, Area, XAxis, YAxis, Tooltip } from "recharts";
export default function DonationChart() {
  const data = [
    {
      name: "Jan",
      uv: 0,
    },
    {
      name: "Feb",
      uv: 0,
    },
    {
      name: "Mar",
      uv: 0,
    },
    {
      name: "Apr",
      uv: 0,
    },
  ];
  return (
    <div>
      <AreaChart
        width={750}
        height={400}
        data={data}
        margin={{
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
        }}
      >
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Area
          type="monotone"
          dataKey="uv"
          stackId="1"
          stroke="#1C4484"
          fill="#1C4484"
        />
      </AreaChart>
    </div>
  );
}
